import moment from "moment";
import React, { Component } from "react";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from "react-toastify";

export default class EditTransfer extends Component {
  constructor(props) {
    super(props);
    this.state = { transfer: {} };
    this.saveData = this.saveData.bind(this);
    this.setData = this.setData.bind(this);
    this.getData = this.getData.bind(this);
    this.handleInptChange = this.handleInptChange.bind(this);
    this.handleRedirect = this.handleRedirect.bind(this);
  }

  /**
   * Init data
   */
  componentWillMount() {
    if (this.props.match.params.hasOwnProperty("id")) {
      //Edit transfer
      const transferId = this.props.match.params.id;
      axios
        .get("/api/transfer-request/" + transferId)
        .then((response) => {
          this.setData(response.data);
        })
        .catch((err) => {
          this.props.history.push("/_404");
        });
    }
  }

  /**
   * Set data of transfer
   * data: Object Transfer
   */
  setData(data) {
    this.setState({
      transfer: data,
    });
  }

  /**
   * Get data of transfer
   */
  getData() {
    return this.state.transfer;
  }

  /**
   * Listen change input
   * event: Object input
   */
  handleInptChange(event) {
    let transferCopy = Object.assign({}, this.state.transfer);
    transferCopy[event.target.name] = event.target.value;
    this.setState({ transfer: transferCopy });
  }

  fireRedirect(e) {
    e.preventDefault();
    this.props.onHandleRedirect(e.currentTarget.getAttribute("href"));
  }

  /**
   * Call function save data from element parent
   */
  saveData() {
    let transfer = this.getData();
    //to top
    window.scrollTo(0, 0);
    axios
      .post("/api/transfer-request/edit/" + transfer.id, transfer)
      .then((response) => {
        if (response.data.hasOwnProperty("success") && response.data.success) {
          toast.success(response.data.message);
        } else {
          Object.keys(response.data.errors).map((key, i) => {
            if ($.isArray(response.data.errors[key])) {
              response.data.errors[key].map((child, i) => {
                toast.error(child);
              });
            } else {
              toast.error(response.data.errors[key]);
            }
          });
        }
      })
      .catch((error) => {
        Object.keys(error.response.data.errors).map((key, i) => {
          if ($.isArray(error.response.data.errors[key])) {
            error.response.data.errors[key].map((child, i) => {
              toast.error(child);
            });
          } else {
            toast.error(error.response.data.errors[key]);
          }
        });
      });
  }

  /**
   * Handle show text with status
   */
  processStatus(status) {
    switch (status) {
      case 5:
        return "振込エラー";
      case 4:
        return "振込済み";
      case 1:
        return "振込中";
      default:
        return "";
    }
  }
  
  /**
   * Handle show text with 7 status
   */
  process7Status(status) {
    switch (status) {
      case 0:
        return "当日扱い";
      case 1:
        return "予約扱い";
      case 2:
        return "モア振込可";
      case 3:
        return "モア入金確約不能";
      case 6:
        return "振込エラー";
      default:
        return "";
    }
  }

  /**
   * Handle show text with account class
   */
  processAccountClass(account_class) {
    switch (account_class) {
      case 1:
        return "普通預金";
      case 2:
        return "当座預金";
      case 4:
        return "貯蓄預金";
      default:
        return "";
    }
  }

  /**
   * Handle redirect
   */
  handleRedirect(e) {
    e.preventDefault();
    this.props.history.push(e.currentTarget.getAttribute("href"));
  }

  render() {
    return (
      <React.Fragment>
        <div className="row">
          <div className="col-sm-12">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <a onClick={this.handleRedirect} href="/home">
                    ダッシュボード
                  </a>
                </li>
                <li className="breadcrumb-item">
                  <a onClick={this.handleRedirect} href="/transfers">
                    銀行振込申請
                  </a>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  銀行振込申請編集
                </li>
              </ol>
            </nav>
          </div>
        </div>
        <main id="main">
          <div className="row justify-content-md-center">
            <div className="col-sm-6">
              <div className="card mb-3">
                <div className="card-header p-4 border-bottom-0">
                  <h4 className="mb-0">銀行振込申請編集</h4>
                </div>
                <div className="card-body">
                  <div className="form-group row">
                    <label className="col-sm-4 col-form-label text-right">
                      ID
                    </label>
                    <div className="col-sm-8">
                      <label className="col-value text-left">
                        {this.state.transfer.id}
                      </label>
                    </div>
                  </div>
                  <div className="form-group row">
                    <label className="col-sm-4 col-form-label text-right">
                      ワーカーID
                    </label>
                    <div className="col-sm-8">
                      <label className="col-value text-left">
                        {this.state.transfer.staffId}
                      </label>
                    </div>
                  </div>
                  <div className="form-group row">
                    <label className="col-sm-4 col-form-label text-right">
                      申請者名
                    </label>
                    <div className="col-sm-8">
                      <label className="col-value text-left">
                        {this.state.transfer.first_last_name}
                      </label>
                    </div>
                  </div>
                  <div className="form-group row">
                    <label className="col-sm-4 col-form-label text-right">
                      メールアドレス
                    </label>
                    <div className="col-sm-8">
                      <label className="col-value text-left">
                        {this.state.transfer.staffEmail}
                      </label>
                    </div>
                  </div>
                  <div className="form-group row">
                    <label className="col-sm-4 col-form-label text-right">
                      取引内容
                    </label>
                    <div className="col-sm-8">
                      <label className="col-value text-left">
                        シェアジョブ 銀行振込申請
                      </label>
                    </div>
                  </div>
                  <div className="form-group row">
                    <label className="col-sm-4 col-form-label text-right">
                      申請額
                    </label>
                    <div className="col-sm-8">
                      <label className="col-value text-left">
                        {this.state.transfer.transfer_amount
                          ? "¥" +
                            parseInt(
                              this.state.transfer.transfer_amount
                            ).toLocaleString()
                          : ""}
                      </label>
                    </div>
                  </div>
                  <div className="form-group row">
                    <label className="col-sm-4 col-form-label text-right">
                      手数料
                    </label>
                    <div className="col-sm-8">
                      <label className="col-value text-left">
                        {this.state.transfer.transfer_fee
                          ? "¥" +
                            parseInt(
                              this.state.transfer.transfer_fee
                            ).toLocaleString()
                          : ""}
                      </label>
                    </div>
                  </div>
                  <div className="form-group row">
                    <label className="col-sm-4 col-form-label text-right">
                      振込額
                    </label>
                    <div className="col-sm-8">
                      <label className="col-value text-left">
                        {this.state.transfer.rmtc
                          ? "¥" +
                            parseInt(this.state.transfer.rmtc).toLocaleString()
                          : ""}
                      </label>
                    </div>
                  </div>
                  <div className="form-group row">
                    <label className="col-sm-4 col-form-label text-right">
                      ステータス
                    </label>
                    <div className="col-sm-8">
                      <label className="col-value text-left">
                        {this.state.transfer.status != null
                          ? this.processStatus(this.state.transfer.status)
                          : "未承認"}
                      </label>
                    </div>
                  </div>
                  <div className="form-group row">
                    <label className="col-sm-4 col-form-label text-right">
                      振込予約指定
                    </label>
                    <div className="col-sm-8">
                      <label className="col-value text-left">
                        {this.state.transfer.seven_status != null
                          ? this.process7Status(this.state.transfer.seven_status)
                          : "未承認"}
                      </label>
                    </div>
                  </div>
                  <div className="form-group row">
                    <label className="col-sm-4 col-form-label text-right">
                      申請日
                    </label>
                    <div className="col-sm-8">
                      <label className="col-value text-left">
                        {this.state.transfer.created_at
                          ? moment(this.state.transfer.created_at).format(
                              "YYYY年MM月DD日 HH:mm"
                            )
                          : ""}
                      </label>
                    </div>
                  </div>
                  <div className="form-group row">
                    <label className="col-sm-4 col-form-label text-right">
                      振込日
                    </label>
                    <div className="col-sm-8">
                      <label className="col-value text-left">
                        {this.state.transfer.transfer_at
                          ? moment(this.state.transfer.transfer_at).format(
                              "YYYY年MM月DD日 HH:mm"
                            )
                          : ""}
                      </label>
                    </div>
                  </div>
                  <div className="form-group row">
                    <label className="col-sm-4 col-form-label text-right">
                      取引ID
                    </label>
                    <div className="col-sm-8">
                      <label className="col-value text-left">
                        {this.state.transfer.tran_id}
                      </label>
                    </div>
                  </div>
                  <div className="form-group row">
                    <label className="col-sm-4 col-form-label text-right">
                      銀行受付番号
                    </label>
                    <div className="col-sm-8">
                      <label className="col-value text-left">
                        {this.state.transfer.receipt_id}
                      </label>
                    </div>
                  </div>
                  <div className="form-group row">
                    <label className="col-sm-4 col-form-label text-right">
                      銀行名
                    </label>
                    <div className="col-sm-8">
                      <label className="col-value text-left">
                        {this.state.transfer.bank_num}　
                        {this.state.transfer.bank_name}
                      </label>
                    </div>
                  </div>
                  <div className="form-group row">
                    <label className="col-sm-4 col-form-label text-right">
                      支店名
                    </label>
                    <div className="col-sm-8">
                      <label className="col-value text-left">
                        {this.state.transfer.bank_branch_num}　
                        {this.state.transfer.bank_branch_name}
                      </label>
                    </div>
                  </div>
                  <div className="form-group row">
                    <label className="col-sm-4 col-form-label text-right">
                      種別
                    </label>
                    <div className="col-sm-8">
                      <label className="col-value text-left">
                        {this.processAccountClass(
                          this.state.transfer.account_class
                        )}
                      </label>
                    </div>
                  </div>
                  <div className="form-group row">
                    <label className="col-sm-4 col-form-label text-right">
                      口座番号
                    </label>
                    <div className="col-sm-8">
                      <label className="col-value text-left">
                        {this.state.transfer.account_num}
                      </label>
                    </div>
                  </div>
                  <div className="form-group row">
                    <label className="col-sm-4 col-form-label text-right">
                      口座名義
                    </label>
                    <div className="col-sm-8">
                      <label className="col-value text-left">
                        {this.state.transfer.account_user_name_kana}
                      </label>
                    </div>
                  </div>
                  <div className="form-group row">
                    <label className="col-sm-4 col-form-label text-right">
                      メモ
                    </label>
                    <div className="col-sm-8">
                      <textarea
                        onChange={this.handleInptChange}
                        name="memo"
                        value={
                          this.state.transfer.memo
                            ? this.state.transfer.memo
                            : ""
                        }
                        className="form-control"
                        rows="8"
                      />
                    </div>
                  </div>
                </div>
                <div className="card-footer text-center">
                  <button
                    onClick={this.saveData}
                    className="btn btn-primary btn-radius btn-lg clearfix"
                  >
                    <span className="size-inherit">保存する</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </main>
        <ToastContainer />
      </React.Fragment>
    );
  }
}
